import {
  AmbientLight,
  Color,
  DirectionalLight,
  GridHelper,
  OrthographicCamera,
  Scene,
  WebGLRenderer
} from 'three';

/**
 * threeSceneManager — Single Responsibility: Setup y gestión de Scene, OrthographicCamera, luces y WebGLRenderer.
 *
 * Contrato público:
 *   createThreeSceneManager(containerElement)
 */
export function createThreeSceneManager(containerElement) {
  const scene = new Scene();
  scene.background = new Color('#05080e');

  const aspect = 1200 / 800;
  const d = 12;
  const camera = new OrthographicCamera(-d * aspect, d * aspect, d, -d, 1, 1000);
  camera.position.set(20, 25, 20);
  camera.lookAt(0, 0, 0);

  const renderer = new WebGLRenderer({ antialias: true });
  renderer.setSize(1200, 800);
  renderer.shadowMap.enabled = true;
  if (containerElement && containerElement.insertBefore && containerElement.firstChild) {
    containerElement.insertBefore(renderer.domElement, containerElement.firstChild);
  }

  const ambientLight = new AmbientLight(0xffffff, 0.8);
  scene.add(ambientLight);

  const dirLight = new DirectionalLight(0xfff0c0, 1.4);
  dirLight.position.set(15, 30, 10);
  dirLight.castShadow = true;
  scene.add(dirLight);

  const gridHelper = new GridHelper(28, 28, 0x38bdf8, 0x1c2738);
  scene.add(gridHelper);

  return { scene, camera, renderer, ambientLight, dirLight, gridHelper };
}
